import type { Volume } from '../types/offer';
export const volumes: Volume[] = [{
  number: '1',
  title: 'THE SUNDAY LOSS',
  description: 'আর্জেন্টিনা কীভাবে তাদের সবচেয়ে বড় কষ্টকে সবচেয়ে বড় শক্তিতে রূপ দিয়েছিল, তার মনস্তত্ত্ব। নিজের ব্যর্থতাগুলো দিয়েও ঠিক সেটাই করতে শিখুন।',
  cover: 'https://cdn.magicpatterns.com/uploads/gieKPipiF4duEA8uQSXcdi/TOMO-1.png'
}, {
  number: '2',
  title: 'THE POTRERO SACRED CODE',
  description: 'যে স্ট্রিট-লেভেল মাইন্ডসেট কোড একেবারে সাধারণ শুরু থেকে চ্যাম্পিয়ন তৈরি করে, তা জেনে নিন। (সরাসরি বাংলাদেশের প্রেক্ষাপটে প্রয়োগযোগ্য)',
  cover: 'https://cdn.magicpatterns.com/uploads/2fVkAsdribYKgenyPPfdiL/TOMO-2.png'
}, {
  number: '3',
  title: 'THE GENEALOGY OF GODS',
  description: 'আর্জেন্টাইন শ্রেষ্ঠত্বের গোপন উত্তরাধিকার। যে প্রজন্মগত মানসিকতা বিশ্বমানের ফলাফল তৈরি করে, সেটি বুঝে নিন।',
  cover: 'https://cdn.magicpatterns.com/uploads/qqDpp3AEf4dhiQCdFmspaP/TOMO-3.png'
}, {
  number: '4',
  title: 'THE PENALTY MINDSET',
  description: 'চরম চাপের মুহূর্তের মনস্তত্ত্বে দক্ষ হয়ে উঠুন। পরীক্ষা, চাকরির ইন্টারভিউ, ক্লায়েন্ট নেগোশিয়েশন ও গুরুত্বপূর্ণ ব্যবসায়িক সিদ্ধান্তে এই ফ্রেমওয়ার্ক ব্যবহার করুন।',
  cover: 'https://cdn.magicpatterns.com/uploads/piJXrEKVGBsvgZHodV5SSH/TOMO-4.png'
}, {
  number: '5',
  title: 'TWO HEARTS, ONE BEAT',
  description: 'আর্জেন্টাইন সংস্কৃতির দ্বৈততা এবং পরস্পরবিরোধী পরিচয়কে অদম্য মানসিক দৃঢ়তায় রূপ দেওয়ার উপায়।',
  cover: 'https://cdn.magicpatterns.com/uploads/4HVgZij8Trj11mizWNHdHZ/TOMO-5.png'
}, {
  number: '6',
  title: 'THE ARCHITECT LEGACY',
  description: 'নিজের শ্রেষ্ঠত্বের সিস্টেম গড়ে তুলুন। আর্জেন্টাইন আর্কিটেকচারাল নীতির আলোকে নিজের জীবনকে একটি মাস্টারপিস হিসেবে ডিজাইন করুন।',
  cover: 'https://cdn.magicpatterns.com/uploads/gWKLx52yPVg1KtF66eqh68/TOMO-6.png'
}];
